export default __webpack_public_path__ + "static/media/about-main-init.b4eae8f8.jpg";